import { Observable, Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterNotificationService } from './../toaster-notification/toaster-notification.service';
import {
  base64ToArrayBuffer,
  saveByteArray,
  convertUTCDateToLocalDateMMDDYYYYHHMMSS,
} from 'src/app/shared/utilities/util';
import { UserFileDownload } from './../../models/userDetail.model';
import { DataCaptureService } from './../../../modules/data-capture/services/data-capture.service';
import {
  SOMETHING_WENT_WRONG,
  ERROR_OCCURED_TRY_AGAIN_LATER,
  NO_WORKFLOWS_FOUND,
} from './../../constants/messages';
import {
  NOTIFICATION_ERROR,
  PRINTER_PROOF_ACTION_URL,
  CP_QP_REPORT_ACTION_URL,
} from './../../constants/constant';
import { LoggingService } from './../../../core/services/logging.service';
import {
  AnnualReportingDetails,
  ViewLogHistoryDetails,
} from './../../models/manageWorkflow.model';
import { ManageWorkflowService } from './../../../modules/manage-workflows/services/manage-workflow.service';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-previous-year-page',
  templateUrl: './previous-year-page.component.html',
  styleUrls: ['./previous-year-page.component.scss'],
})
export class PreviousYearPageComponent implements OnInit {
  @Input() year: string;
  @Input() workflowType: string;
  @Input() isCpQpNomination = false;
  @Input() isReportingWorkflow = false;
  @Input() showAssetName = false;
  @Input() hideSearchBar = false;
  @Input() hideRegionFilter = false;
  @Input() hideAssetFilter = false;
  public loadAllFilters = false;
  public sub;

  workflowDataList: AnnualReportingDetails[];
  public selectedRegions: number[] = [];
  public selectedAssets: number[] = [];
  public selectedDeposits: number[] = [];
  filterData: any;
  searchWorkflows: any;
  initialWorkflowDataList: any;
  tableHeaders: any;
  searchText = '';
  showLoader: boolean;
  alert: { type: any; message: any };
  responseWorkflowList: any;
  viewLogArray: any[];
  showViewLogHistoryPopUp: boolean;
  viewLogHeaderName: string;
  public noWorkflowsText = NO_WORKFLOWS_FOUND;

  constructor(
    private manageWorkflow: ManageWorkflowService,
    private ref: ChangeDetectorRef,
    private dataCaptureService: DataCaptureService,
    private toasterNotificationService: ToasterNotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    if (this.year) {
      this.loadData();
    }
    this.isCpQpNomination ? this.getcpQpNomonationReportingHeaders() : '';
    this.isReportingWorkflow ? this.getReportingWorkflowsHeaders() : '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.year &&
      changes.year.currentValue &&
      !changes.year.firstChange
    ) {
      this.loadData();
    }
  }

  public loadData(): void {
    this.showLoader = true;
    this.manageWorkflow
      .getDashboardDetails(this.workflowType, '1', this.year, 2, 0)
      .subscribe(
        (value) => {
          this.workflowDataList = [];
          const workflowDataList = value;
          if (workflowDataList.length) {
            workflowDataList.forEach((workflowData: AnnualReportingDetails) => {
              if (workflowData) {
                workflowData =
                  this.manageWorkflow.getWorkflowStatus(workflowData);
              }
            });
            this.responseWorkflowList = workflowDataList;
            this.filterData =
              this.manageWorkflow.getFilterData(workflowDataList);
            this.getTabSelectedData();
            this.loadAllFilters = true;
          }
          this.showLoader = false;
        },
        (error) => {
          this.loggingService.logException(error);
          this.showLoader = false;
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: SOMETHING_WENT_WRONG,
          };
        }
      );
  }

  public onRegionSelect(item): void {
    this.selectedRegions = item;
    this.selectedAssets = [];
    this.selectedDeposits = [];
    this.getFilteredData();
  }

  public onAssetSelect(item): void {
    this.selectedAssets = item;
    this.selectedDeposits = [];
    this.getFilteredData();
  }

  public onDepositSelect(item): void {
    this.selectedDeposits = item;
    this.getFilteredData();
  }

  public onSearchInput(input: string): void {
    this.searchText = input;
    if (this.searchText === '') {
      this.onClearFilter();
    } else {
      this.selectedRegions = [];
      this.selectedAssets = [];
      this.selectedDeposits = [];
      const workflowData = this.workflowDataList;
      this.getSearchList(workflowData);
    }
  }

  public getFilteredData(): void {
    let workflowData = [];
    this.searchText = '';
    const allRows = this.setFilterData();
    workflowData = this.formatData(allRows);
    this.workflowDataList = workflowData;
  }

  public getTabSelectedData(): void {
    let dataList = [];
    const allRows = this.setFilterData();
    dataList = this.formatData(allRows);
    this.searchWorkflows = _.cloneDeep(dataList);
    this.workflowDataList = [];
    this.workflowDataList = _.cloneDeep(dataList);
    this.initialWorkflowDataList = _.cloneDeep(dataList);
    this.getSearchList(this.searchWorkflows);
  }

  public getSearchList(workfloDataList: AnnualReportingDetails[]): void {
    let data = [];
    data = _.cloneDeep(workfloDataList);
    workfloDataList.forEach((element, index) => {
      data[index].data = workfloDataList[index].data.filter((item) => {
        return (
          (item.assignee &&
            item.assignee
              .toLowerCase()
              .includes(this.searchText.toLowerCase())) ||
          (item.depositName &&
            item.depositName
              .toLowerCase()
              .includes(this.searchText.toLowerCase()))
        );
      });
      const regionIndex = this.workflowDataList.findIndex(
        (x) => x.regionID === element.regionID
      );
      if (regionIndex > -1) {
        this.workflowDataList[regionIndex].data = data[index].data;
      }
    });
  }

  public setFilterData(): any {
    let responseRows = [];
    let allRows = [];
    responseRows = this.responseWorkflowList;
    if (this.selectedDeposits.length) {
      for (const deposit of this.selectedDeposits) {
        const rowData = responseRows.filter(
          (x: AnnualReportingDetails) => x.depositID === deposit
        );
        allRows = allRows.concat(rowData);
      }
    } else if (this.selectedAssets.length) {
      for (const asset of this.selectedAssets) {
        const rowData = responseRows.filter(
          (x: AnnualReportingDetails) => x.assetID === asset
        );
        allRows = allRows.concat(rowData);
      }
    } else if (this.selectedRegions.length) {
      for (const region of this.selectedRegions) {
        const rowData = responseRows.filter(
          (x: AnnualReportingDetails) => x.regionID === region
        );
        allRows = allRows.concat(rowData);
      }
    } else {
      allRows = responseRows;
    }
    return allRows;
  }

  public formatData(allRows): any {
    try {
      const dataList = [];
      const filterData = this.filterData;
      const grouped = _.groupBy(allRows, 'regionID');
      const assetData = _.groupBy(allRows, 'assetID');
      const regionKeys = Object.keys(grouped);
      const headersData = this.responseWorkflowList;
      if (!this.showAssetName) {
        for (const key of regionKeys) {
          const headerIndex =
            headersData &&
            headersData.length &&
            headersData.findIndex(
              (x) => x.regionID === filterData[key].regionID
            );
          let headers;
          if (headerIndex > -1 && headersData[headerIndex].headers) {
            headers = headersData[headerIndex].headers;
          } else {
            headers = _.cloneDeep(this.tableHeaders, true);
          }
          dataList.push({
            regionName: filterData[key].regionName,
            regionID: filterData[key].regionID,
            headers,
            assetName: filterData[key].assetName,
            data: grouped[key],
            assets: filterData[key].assets,
            deposits: filterData[key].deposits,
          });
        }
      } else {
        for (const key of regionKeys) {
          const headerIndex =
            headersData &&
            headersData.findIndex(
              (x) => x.regionID === filterData[key].regionID
            );
          let headers;
          if (headerIndex > -1 && headersData[headerIndex].headers) {
            headers = headersData[headerIndex].headers;
          } else {
            headers = _.cloneDeep(this.tableHeaders, true);
          }
          for (const asset of filterData[key].assets) {
            if (assetData[asset]) {
              dataList.push({
                assetName: assetData[asset][0].assetName,
                regionID: filterData[key].regionID,
                headers,
                data: assetData[asset],
                assets: filterData[key].assets,
                deposits: filterData[key].deposits,
              });
            }
          }
        }
      }

      dataList.forEach((element, index) => {
        dataList[index].data = _.orderBy(
          dataList[index].data,
          ['depositName', 'assignee', 'workflowStatusName'],
          ['asc', 'asc', 'asc']
        );
      });
      console.log(dataList);
      return dataList;
    } catch (error) {
      this.loggingService.logTrace(
        'cp-qp-nomination component -> formatNominationData()' + error
      );
    }
  }

  public onClearFilter(): void {
    this.searchText = '';
    this.selectedRegions = [];
    this.selectedAssets = [];
    this.selectedDeposits = [];
    this.reassignWorkflowData();
  }

  public reassignWorkflowData(): void {
    try {
      this.workflowDataList.forEach((element) => {
        const index = this.initialWorkflowDataList.findIndex(
          (x) => x.regionID === element.regionID
        );
        if (index > -1) {
          this.initialWorkflowDataList[index].headers = element.headers;
        }
      });
      this.workflowDataList = _.cloneDeep(this.initialWorkflowDataList);
      this.rerenderComponent();
    } catch (error) {
      this.loggingService.logTrace(
        'cp-qp-nomination component -> reassignNominationData()' + error
      );
    }
  }

  public getcpQpNomonationReportingHeaders(): void {
    const headers = [
      {
        name: 'Deposit Name',
        key: 'depositName',
        sortType: 'string',
        type: 'searchName',
        width: '200px',
      },
      {
        name: 'Type',
        key: 'reportingName',
        sortType: 'string',
        type: 'string',
        width: '130px',
      },
      {
        name: 'CP/QPs',
        key: 'cpQpType',
        sortType: 'string',
        type: 'string',
        width: '160px',
      },
      {
        name: 'assignee',
        key: 'assignee',
        sortType: 'string',
        type: 'link-searchName',
        width: '180px',
      },
      {
        name: 'Status',
        key: 'workflowStatusName',
        sortType: 'string',
        type: 'string',
        width: '200px',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'status-button',
        width: '200px',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'nomination-btn',
        width: '150px',
      },
    ];
    this.tableHeaders = headers;
  }

  public getReportingWorkflowsHeaders(): void {
    const headers = [
      {
        name: 'Deposit Name',
        key: 'depositName',
        type: 'searchName',
        sortType: 'string',
        width: '150px',
      },
      {
        name: 'Workflow',
        key: 'reportingName',
        sortType: 'string',
        type: 'link-searchName',
        width: '130px',
      },
      {
        name: 'Type',
        key: 'cpQpType',
        sortType: 'string',
        type: 'string',
        width: '120px',
      },
      {
        name: 'CP/QPs',
        key: 'assignee',
        sortType: 'string',
        type: 'link-assignee',
        width: '200px',
      },
      {
        name: 'Status',
        key: 'workflowStatusName',
        sortType: 'string',
        type: 'string',
        width: '140px',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'status-button',
        width: '100px',
      },
      {
        name: '',
        key: '',
        sortType: '',
        type: 'view-lock-export-view-only-button',
        width: '300px',
      },
    ];
    this.tableHeaders = headers;
  }

  public rerenderComponent(): void {
    setInterval(() => {
      this.ref.detectChanges();
    }, 500);
  }

  /**
   * @description function calls when user click on export excel
   *
   * @param {*} item
   * @memberof ConsumerReportingWorkflowsComponent
   */
  public onExportExcel(item): void {
    this.showLoader = true;
    const tabCode = this.manageWorkflow.getTabCodeFromReportingName(
      item.reportingCode,
      item.wfLevel1OwnershipType
    );
    this.dataCaptureService
      .downloadExcelFile(item.workflowID, item.yearCode, tabCode)
      .subscribe(
        (response: UserFileDownload) => {
          if (response) {
            const sampleBytes = base64ToArrayBuffer(response.fileContents);
            saveByteArray([sampleBytes], response.fileDownloadName);
          } else {
            this.toasterNotificationService.showErrorNotification(
              'Unable to export excel.'
            );
          }
          this.showLoader = false;
        },
        (error) => {
          this.loggingService.logException(error);
          this.showLoader = false;
          this.toasterNotificationService.showErrorNotification(
            'Unable to export excel.'
          );
        }
      );
  }

  /**
   * @description function used to call when user click on link in table or view button
   *
   * @param {*} item
   * @memberof ConsumerReportingWorkflowsComponent
   */
  public openLink(item): void {
    if (item.workflowType == '2') {
      this.router.navigateByUrl(
        `${this.router.url}/${PRINTER_PROOF_ACTION_URL}/${item.workflowID}/${item.yearCode}`
      );
    } else {
      this.router.navigateByUrl(
        `${this.router.url}/data-capture/${item.workflowID}/${item.yearCode}`
      );
    }
  }

  public onLockUnlock(item) {
    this.manageWorkflow
      .getViewLogHistory(item.workflowID, item.yearCode)
      .subscribe(
        (response) => {
          try {
            this.viewLogArray = [];
            if (response && response.value && response.value.length) {
              response.value.forEach((element) => {
                const obj: ViewLogHistoryDetails = {};
                obj.firstName = element.firstName;
                obj.lastName = element.lastName;
                obj.tab = element.tab;
                obj.actionTaken = element.actionTaken;
                obj.updatedOn = convertUTCDateToLocalDateMMDDYYYYHHMMSS(
                  element.updatedOn
                );
                this.viewLogArray.push(obj);
              });
            }
          } catch (error) {
            this.loggingService.logTrace(
              'consumer-reporting-workflows component -> onLockUnlock()' + error
            );
          }
        },
        (error) => {
          this.loggingService.logException(error);
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
          };
        }
      );
    this.showViewLogHistoryPopUp = true;
    this.viewLogHeaderName = 'Data Entry';
  }

  public onConsentEvent(workflow: AnnualReportingDetails): void {
    this.router.navigateByUrl(
      `${this.router.url}/${PRINTER_PROOF_ACTION_URL}/${workflow.workflowID}/${workflow.yearCode}`
    );
  }

  public onSelectCpQpReport(item: AnnualReportingDetails): void {
    this.router.navigateByUrl(
      `${this.router.url}/${CP_QP_REPORT_ACTION_URL}/${item.workflowID}/${item.yearCode}`
    );
  }

  public onCloseViewLogHistoryPopup(): void {
    this.showViewLogHistoryPopUp = false;
  }

  public openNominationLink(item): void {
    if (item.assigneeIDs) {
      this.router.navigateByUrl(`${this.router.url}/user/${item.assigneeIDs}`);
    }
  }

  public viewNomination(item): void {
    if (item.assigneeIDs) {
      this.router.navigateByUrl(
        `${this.router.url}/cp-nomination/${item.assigneeIDs}/${item.workflowID}/${item.yearCode}`
      );
      // this.router.navigateByUrl(`${this.router.url}/consent-to-publish/${item.assigneeIDs}/${item.workflowID}/${item.yearCode}`);
    }
  }

  ngOnDestroy() {}
}
